function Questions() {
  return(
    <div>
        <p>Questions</p>
    </div>
    )
  }
  
  export default Questions;